import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Locations from './Locations';
import Rooms from './Rooms';
import Devices from './Devices';
import Warehouses from './Warehouses';
import Spares from './Spares';
import SpareUnits from './SpareUnits';
import BHELContacts from './BHELContacts';
import VendorContacts from './VendorContacts';
import OEMEscalations from './OEMEscalations';

const GROUPS = [
  {
    label: 'Infrastructure',
    tabs: [
      { key: 'locations',  label: 'Locations',      component: Locations },
      { key: 'rooms',      label: 'Rooms',           component: Rooms },
      { key: 'devices',    label: 'Room Inventory',  component: Devices },
    ],
  },
  {
    label: 'Spares',
    tabs: [
      { key: 'warehouses',   label: 'Warehouses',    component: Warehouses },
      { key: 'spares',       label: 'Spares Master', component: Spares },
      { key: 'spare-units',  label: 'Spare Units',   component: SpareUnits },
    ],
  },
  {
    label: 'Contacts',
    tabs: [
      { key: 'bhel-contacts',    label: 'BHEL Contacts',    component: BHELContacts },
      { key: 'vendor-contacts',  label: 'Vendor Contacts',  component: VendorContacts },
      { key: 'oem-escalations',  label: 'OEM Escalations',  component: OEMEscalations },
    ],
  },
];

const ALL_TABS = GROUPS.flatMap(g => g.tabs);

function tabFromPath(pathname) {
  const seg = pathname.split('/admin/')[1]?.split('/')[0] || '';
  return ALL_TABS.find(t => t.key === seg)?.key || ALL_TABS[0].key;
}

export default function AdminHub() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = tabFromPath(location.pathname);
  const ActiveComponent = ALL_TABS.find(t => t.key === activeKey)?.component || Locations;

  const go = (key) => navigate(`/admin/${key}`, { replace: true });

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="px-6 pt-6 pb-0 bg-[#F5F3FC]">
        <p className="text-xs font-semibold text-[#C1278D] uppercase tracking-widest mb-1">System Administration</p>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Admin Panel</h1>

        {/* Tab bar — grouped */}
        <div className="flex items-end gap-6 border-b border-gray-200">
          {GROUPS.map((group) => (
            <div key={group.label} className="flex flex-col gap-0">
              <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest px-1 mb-1">
                {group.label}
              </span>
              <div className="flex items-end gap-0.5">
                {group.tabs.map(tab => {
                  const isActive = tab.key === activeKey;
                  return (
                    <button
                      key={tab.key}
                      onClick={() => go(tab.key)}
                      className={`px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-all whitespace-nowrap ${
                        isActive
                          ? 'border-[#C1278D] text-[#C1278D] bg-white'
                          : 'border-transparent text-gray-500 hover:text-[#3D3562] hover:bg-white/60'
                      }`}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Active page — rendered below the tab bar, no extra padding */}
      <div className="flex-1 overflow-auto bg-[#F5F3FC]">
        <ActiveComponent embedded />
      </div>
    </div>
  );
}
